"use client";

import { createContext, type ReactNode, useContext, useEffect, useSyncExternalStore } from "react";
import type { Session, SessionState } from "./session";

const SessionContext = createContext<Session | null>(null);

/** Provides one Session to the screens and restores it once on mount. */
export function SessionProvider({ session, children }: { session: Session; children: ReactNode }) {
  useEffect(() => {
    void session.restore();
  }, [session]);
  return <SessionContext.Provider value={session}>{children}</SessionContext.Provider>;
}

export function useSession(): { session: Session; state: SessionState } {
  const session = useContext(SessionContext);
  if (session === null) throw new Error("useSession needs a SessionProvider");
  const state = useSyncExternalStore(
    (listener) => session.subscribe(listener),
    () => session.snapshot,
    () => session.snapshot,
  );
  return { session, state };
}
